module.exports = __webpack_public_path__ + "img/curv_20_a.fe1d3d7c.jpg";